<style lang="less" scoped>
.navbar{
  margin-bottom: constant(safe-area-inset-bottom);
  position: fixed;
  left:0;
  bottom:0;
  width:100vw;
  height:65px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  z-index: 1020;
  .nav{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .nav-four{
      width: 20%;
      height:100%;
      a{
        width: 100%;
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        div{
          img{
            height:5.6vw;
          }
          p{
            font-size: 10px;
            line-height: 1;
            color:#4c4c4c;
            margin:0;
            -webkit-text-size-adjust: 100%;
          }
        }
      }
    }
    .nav-three{
      width: 33.3%;
    }
  }
}
@media screen and (min-width:750px){
  .navbar{
    width: 750px;
    height:80px;
    left:calc(50% - 375px);
    .nav{
      .nav-four{
        a{
          div{
            img{
              height:34px;
            }
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="navbar">
    <div class="nav">
      <div :class="$i18n.locale === 'zh' ? 'nav-four' : 'nav-four nav-three'">
        <router-link to="/">
          <div>
            <img v-show="nowIndex !== 0" src="../assets/images/nav1.png" alt="">
            <img v-show="nowIndex == 0"  src="../assets/images/nav1-color.png" alt="">
            <p>{{$t('lang.home')}}</p>
          </div>
        </router-link>
      </div>
      <div :class="$i18n.locale === 'zh' ? 'nav-four' : 'nav-four nav-three'">
        <router-link to="/speakers">
          <div>
            <img v-show="nowIndex !== 1" src="../assets/images/nav2.png" alt="">
            <img v-show="nowIndex == 1"  src="../assets/images/nav2-color.png" alt="">
            <p>{{$t('lang.speakers')}}</p>
          </div>
        </router-link>
      </div>
      <div :class="$i18n.locale === 'zh' ? 'nav-four' : 'nav-four nav-three'">
        <router-link to="/agenda">
          <div>
            <img v-show="nowIndex !== 2" src="../assets/images/nav3.png" alt="">
            <img v-show="nowIndex == 2"  src="../assets/images/nav3-color.png" alt="">
            <p>{{$t('lang.agenda')}}</p>
          </div>
        </router-link>
      </div>
      <div  :class="$i18n.locale === 'zh' ? 'nav-four' : 'nav-four nav-three'" v-if="$i18n.locale === 'zh'">
        <router-link to="/zoom">
          <div>
            <img v-show="nowIndex !== 3" src="../assets/images/nav5.png" alt="">
            <img v-show="nowIndex == 3"  src="../assets/images/nav5-color.png" alt="">
            <p>连麦</p>
          </div>
        </router-link>
      </div>
      <div  :class="$i18n.locale === 'zh' ? 'nav-four' : 'nav-four nav-three'" v-if="$i18n.locale === 'zh'">
        <router-link to="/search">
          <div>
            <img v-show="nowIndex !== 4" src="../assets/images/nav4.png" alt="">
            <img v-show="nowIndex == 4"  src="../assets/images/nav4-color.png" alt="">
            <p>{{$t('lang.search')}}</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      nowIndex: 0
    }
  },
  created () {
    this.changeIndex()
  },
  watch: {
    '$route.path': {
      handler: function (newer, older) {
        this.changeIndex()
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    changeIndex: function () {
      let self = this
      // console.log(self.$route.path)
      if (self.$route.path === '/') {
        self.nowIndex = 0
      } else if (self.$route.path === '/speakers') {
        self.nowIndex = 1
      } else if (self.$route.path === '/agenda') {
        self.nowIndex = 2
      } else if (self.$route.path === '/zoom') {
        self.nowIndex = 3
      } else if (self.$route.path === '/search') {
        self.nowIndex = 4
      } else {
        self.nowIndex = null
      }
      // if (index !== self.nowIndex) {
      //   self.nowIndex = index
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navbar.vue